<template>
  <ion-app>
    <ion-loading :is-open="mainStoreInstance.$state.loading.show" :message="mainStoreInstance.$state.loading.message"> </ion-loading>
  
    <ion-menu content-id="main-content">
      <ion-header>
        <ion-toolbar>
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="--padding-bottom: max(60px, calc(env(safe-area-inset-bottom) + 60px));">
        <ion-list>
          <ion-item 
                    button 
                    @click="openSesiones" 
                    v-if="userAuth().hasRole('coordinador de actividad') || userAuth().hasRole('profesor')"
                    >
            Clases
          </ion-item>

          <ion-item button @click="openEventos">
            Eventos
          </ion-item>

          <ion-item 
                    button 
                    @click="openQRScanner"
                    v-if="userAuth().hasRole('coordinador de actividad')"
                    >
            Lector QR
          </ion-item>

          <ion-item button @click="openMensajes">
            Mensajes
          </ion-item>

          <ion-item button @click="openAlquileres">
            Alquileres
          </ion-item>

          <ion-item button @click="openSaldo">
            💳 Mi Saldo
          </ion-item>

          <ion-item button @click="openIncidencias">
            Incidencias
          </ion-item>

          <ion-item 
                      button 
                      @click="openWhatsappLauncher"
                      v-if="userAuth().can('Buscar alumnos para Whatsapp Launcher')"
                      >
            Lanzador de Whatsapps
          </ion-item>

          <ion-item 
                      button 
                      @click="openDeteccionNecesidades"
                      v-if="userAuth().can('Añadir deteccion de necesidades')"
                      >
            Detección de necesidades
          </ion-item>

          <ion-item 
                    button 
                    @click="openEntregas"
                    v-if="userAuth().hasRole('coordinador de actividad')"
                    >
            Entregas
          </ion-item>

          <ion-item button @click="openDomotica">
            Domótica
          </ion-item>

          <ion-item button @click="openLiquidacion">
            Liquidación
          </ion-item>
        </ion-list>
        <div style="text-align: center; position: absolute; bottom: 0; width: 100%; padding-bottom: max(20px, env(safe-area-inset-bottom)); left: 0; right: 0;">
          <ion-note style="font-size: smaller;">
            Versión {{ require('../package.json').version }}
          </ion-note>
          <div style="display: flex; align-items: center; justify-content: center; margin-top: 4px;">
            <ion-note>Hola, {{ tools().getShortName( currentUserStore().user?.name || '') }}</ion-note>
            <a href="#" @click.prevent="logout" style="margin-left: 12px; color: var(--ion-color-danger); text-decoration: none; display: inline-flex; align-items: center;">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
            </a>
        </div>
        </div>
      </ion-content>
    </ion-menu>
    
    <ion-router-outlet id="main-content" />
    
    <!-- Floating Message Indicator -->
    <FloatingMessageIndicator />
  </ion-app>
</template>

<script lang="ts" setup>
import { mainStore } from '@/stores/mainStore';
import { IonApp, IonLoading, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonNote, IonRouterOutlet, IonItem, IonList, menuController } from '@ionic/vue';
import tools from '@/composables/tools';
import router from '@/router';
import { currentUserStore } from '@/stores/currentUser'
import userAuth from './composables/userAuth';
import FloatingMessageIndicator from '@/components/FloatingMessageIndicator.vue';

const mainStoreInstance = mainStore();

const closeMenu = async() => {
      await menuController.toggle();
}

const openSesiones = () => {
  tools().setLog('Abre lista de sesiones desde el menú');
  router.push({ name: 'Sesiones'})
  closeMenu();
};

const logout = async () => {
  await closeMenu();
  await userAuth().logout();
};

const openAlquileres = () => {
  tools().setLog('Abre la sección de alquileres desde el menú');
  location.href = '/alquileres'; //me da error si no lo hago asi.. .tengo q solucionarlo
};

const openSaldo = () => {
  tools().setLog('Abre la sección de saldo desde el menú');
  location.href = '/saldo';
  closeMenu();
};

const openEventos = () => {
  tools().setLog('Abre lista de eventos desde el menú');
  location.href = '/eventos'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openMensajes = () => {
  tools().setLog('Abre lista de mensajes desde el menú');
  location.href = '/mensajes'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openIncidencias = () => {
  tools().setLog('Abre lista de incidencias desde el menú');
  location.href = '/Organizacion/incidencias'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openQRScanner = () => {
  tools().setLog('Abre el escanner QR desde el menú');
  location.href = 'https://escaner.gest.galidancia.com'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openDeteccionNecesidades = () => {
  tools().setLog('Abre formulario de detección de necesidades');
  location.href = '/necesidades'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Eventos' });
  closeMenu();
};

const openWhatsappLauncher = () => {
  tools().setLog('Abre el whatsapp launcher');
  location.href = '/whatsappLauncher'; //me da error si no lo hago asi.. .tengo q solucionarlo
  //router.push({ name: 'Whatsapp Launcher' });
  closeMenu();
};

const openEntregas = () => {
  tools().setLog('Abre lista de entregas desde el menú');
  router.push('/entrega');
  closeMenu();
};

const openDomotica = () => {
  tools().setLog('Abre la sección de domótica desde el menú');
  location.href = '/domotica';
  closeMenu();
};

const openLiquidacion = () => {
  tools().setLog('Abre la sección de liquidación desde el menú');
  location.href = '/liquidacion';
  closeMenu();
};
</script>
